<div class="tt-c-review-filters">
  <tt-listbox v-for="lbv in listBoxValues"
              :deselectable="true"
              :model="lbv.model"
              @change="onChange(lbv.filter, $event)"
              :isRating="lbv.filter.isRating"
              :label="lbv.label"
              :multiSelect="lbv.multiSelect"
              :options="lbv.filter.options"
              :showCounts="lbv.filter.showCounts"
              :subLabel="lbv.subLabel"
              :key="lbv.filter.group + '-' + lbv.filter.name"></tt-listbox>
</div>
